import React from 'react';
import { Typography } from '@mui/material';

import { showMoney } from '../../shared';

import { StyledContractOverviewCardText } from './ContractOverviewCard.styled';

export default function MonthlyPremium({ customer, monthlyPremium, addons }) {
  if (!!addons && !!addons?.title) {
    const addOnTitle = addons?.title || '';
    const addOnPrice = addons?.price || 0;
    const premiumPrice = monthlyPremium - addOnPrice;
    const policyName = customer?.contract?.policyName || '';

    return (
      <>
        <StyledContractOverviewCardText>
          <Typography variant="p" component="span">
            {showMoney(premiumPrice)}
          </Typography>

          <Typography variant="p" component="span">
            {policyName}
          </Typography>
        </StyledContractOverviewCardText>

        <StyledContractOverviewCardText>
          <Typography variant="p" component="span">
            {showMoney(addOnPrice)}
          </Typography>

          <Typography variant="p" component="span">
            {addOnTitle}
          </Typography>
        </StyledContractOverviewCardText>
      </>
    );
  }

  return (
    <StyledContractOverviewCardText>
      <Typography variant="p">{showMoney(monthlyPremium)}</Typography>{' '}
    </StyledContractOverviewCardText>
  );
}
